import { makeStyles } from 'tss-react/mui';
import { colors, theme } from '../theme';

const useCreateAccountStyles = makeStyles()(() => ({
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.padding.m,
    backgroundColor: theme.background.paper,
    padding: theme.padding.l,
    margin: theme.margin.l,
    borderRadius: theme.borderRadius.m,
    width: '35vw',
  },
  dividerLine: {
    width: '100%',
    border: theme.border,
    margin: `${theme.margin.m} 0`,
  },
  successMessage: {
    fontFamily: theme.fontFamily,
    color: colors.green['400'],
    marginBottom: theme.margin.m,
    fontSize: theme.fontSize.default,
    marginTop: theme.margin.xs,
    fontWeight: theme.fontWeight.medium,
    marginLeft: theme.margin.xs,
  },
}));

export default useCreateAccountStyles;
